import { useState } from 'react';

export default function PortfolioSection() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');

  const categories = ['Todos', 'Realismo', 'Mini Realismo', 'Black & Grey', 'Geométrico'];

  const portfolioItems = [
    {
      id: 1,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/2d9240e73d60d0bbdc9951879eb5cb9f.jpeg',
      title: 'Guerrero Espartano',
      category: 'Realismo',
      description: 'Tatuaje realista de guerrero espartano en pierna'
    },
    {
      id: 2,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/b958601d2fe01b779833d541070c8006.jpeg',
      title: 'Medusa con Serpientes',
      category: 'Realismo',
      description: 'Tatuaje realista de Medusa con serpientes en brazo'
    },
    {
      id: 3,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/07baae0982c6d7bb207ca36b5198b2f1.jpeg',
      title: 'Retrato Las Vegas',
      category: 'Realismo',
      description: 'Retrato realista con lettering Las Vegas en antebrazo'
    },
    {
      id: 4,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/77df1f9831b6bbd1d4ce72a3c80c5e7c.jpeg',
      title: 'Jesucristo',
      category: 'Realismo',
      description: 'Retrato realista de Jesucristo con corona de espinas'
    },
    {
      id: 5,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/8704ea58437f2203a5e5ca1fd0a297e8.jpeg',
      title: 'Tigre Realista',
      category: 'Realismo',
      description: 'Tatuaje de tigre con técnica realista en brazo'
    },
    {
      id: 6,
      image: 'https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/27a2a60a63df455e9ede8acd56ae0cf8.jpeg',
      title: 'León Majestuoso',
      category: 'Realismo',
      description: 'Retrato realista de león majestuoso en antebrazo'
    }
  ];

  const filteredItems = selectedCategory === 'Todos' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === selectedCategory);

  return (
    <section id="portfolio" className="py-32 bg-neutral-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="relative max-w-7xl mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block mb-6">
            <span className="text-amber-600 text-sm font-bold uppercase tracking-widest px-4 py-2 border-2 border-amber-600">
              Portfolio
            </span>
          </div>
          <h2 
            className="text-[50px] sm:text-[70px] md:text-[90px] leading-none font-bold text-white mb-6"
            style={{ 
              fontFamily: 'Bebas Neue, sans-serif',
              letterSpacing: '8px'
            }}
          >
            GALERÍA ELITE
          </h2>
          <p className="text-neutral-400 text-base md:text-lg max-w-2xl mx-auto px-4">
            Explora una selección de mis mejores trabajos en realismo y mini realismo
          </p>
        </div>

        <div className="flex justify-center gap-2 md:gap-4 mb-10 md:mb-16 flex-wrap px-2">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-3 font-bold text-sm tracking-wider transition-all cursor-pointer whitespace-nowrap ${
                selectedCategory === category
                  ? 'bg-amber-600 text-white'
                  : 'bg-neutral-800 text-neutral-400 hover:bg-neutral-700 hover:text-white'
              }`}
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%)' }}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {filteredItems.map((item) => (
            <div
              key={item.id}
              className="group relative overflow-hidden bg-neutral-800 cursor-pointer"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0 100%)' }}
            >
              <div className="relative w-full h-72 sm:h-80 md:h-96">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <span className="inline-block text-amber-600 text-xs font-bold uppercase tracking-wider mb-2 px-3 py-1 bg-neutral-900/80 backdrop-blur-sm">
                  {item.category}
                </span>
                <h3 className="text-white text-xl font-bold mb-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                  {item.title}
                </h3>
                <p className="text-neutral-400 text-sm">
                  {item.description}
                </p>
              </div>

              <div className="absolute top-4 right-4 w-10 h-10 bg-amber-600 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-eye-line text-white text-lg"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <a
            href="https://www.instagram.com/Daro_tattoo_"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-neutral-800 text-white px-8 py-4 hover:bg-neutral-700 transition-all cursor-pointer whitespace-nowrap border-2 border-neutral-600"
            style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)' }}
          >
            <i className="ri-instagram-line text-xl"></i>
            <span className="font-bold tracking-wider">VER MÁS EN INSTAGRAM</span>
            <i className="ri-arrow-right-up-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
